export default {
  types: [
    { value: 1, label: 'all' },
    { value: 2, label: 'pending' },
    { value: 3, label: 'accepted' },
    { value: 4, label: 'recused' },
    { value: 5, label: 'finished' },
    { value: 6, label: 'cancelled' },
  ],
};
